import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'semantic-ui-react';
import { addModifiers } from '../../shared/helpers';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import './Breadcrumbs.scss';

interface Props {
  items: { link?: string; name?: React.ReactNode; onClickCapture?: () => void; LinkComponent?: typeof Link }[];
}

const Divider = () => <span className="breadcrumbs__divider">{' > '}</span>;

export const Breadcrumbs = ({ items }: Props) => {
  return (
    <Breadcrumb className="breadcrumbs">
      {items.map((item, i) => {
        const isActive = i === items.length - 1;
        const content = (
          <span className={addModifiers('breadcrumbs__item', isActive ? ['active'] : [])}>
            {item.name ?? <FormattedMessageHelper id="breadcrumbs.loading" />}
          </span>
        );

        const LinkComponent = item.LinkComponent ?? Link;
        return (
          <React.Fragment key={i}>
            <span onClickCapture={item.onClickCapture}>
              <Breadcrumb.Section>
                {item.link ? (
                  <LinkComponent to={item.link} className="link">
                    {content}
                  </LinkComponent>
                ) : (
                  content
                )}
              </Breadcrumb.Section>
            </span>
            {items[i + 1] && <Divider />}
          </React.Fragment>
        );
      })}
    </Breadcrumb>
  );
};
